module.exports = __webpack_public_path__ + "static/media/dashboard_features.fdaea432.jpg";